export const TEMPLATE_PROVISIONING_TARGET = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
} as const;

export type TemplateProvisioningTarget =
  (typeof TEMPLATE_PROVISIONING_TARGET)[keyof typeof TEMPLATE_PROVISIONING_TARGET];

export const PROVISIONING_TARGET_STATUS = {
  FAILED: 'failed',
  PENDING: 'pending',
  SUCCESS: 'success',
} as const;

export type ProvisioningTargetStatus = (typeof PROVISIONING_TARGET_STATUS)[keyof typeof PROVISIONING_TARGET_STATUS];
